export default __webpack_public_path__ + "static/media/spot_lesson_img.43505fcc.png";